import React from 'react';
import SkeletonCard from './SkeletonCard';

interface SkeletonGridProps {
  darkMode: boolean;
  count?: number;
}

const SkeletonGrid: React.FC<SkeletonGridProps> = ({ darkMode, count = 6 }) => (
  <div className="grid gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} darkMode={darkMode} />
    ))}
  </div>
);

export default SkeletonGrid;
